import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="text-xl font-bold">DAO Watch Automation</h3>
            <p className="text-gray-300 mt-2">
              Streamlining DAO governance research and organization
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row md:space-x-8">
            <div className="mb-4 md:mb-0">
              <h4 className="text-lg font-semibold mb-2">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a href="/" className="text-gray-300 hover:text-white transition">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/submit" className="text-gray-300 hover:text-white transition">
                    Submit Proposals
                  </a>
                </li>
                <li>
                  <a href="/history" className="text-gray-300 hover:text-white transition">
                    History
                  </a>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-2">Support</h4>
              <ul className="space-y-2">
                <li>
                  <button type="button" className="text-gray-300 hover:text-white transition">
                    Help Center
                  </button>
                </li>
                <li>
                  <button type="button" className="text-gray-300 hover:text-white transition">
                    Contact Us
                  </button>
                </li>
                <li>
                  <button type="button" className="text-gray-300 hover:text-white transition">
                    Feedback
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} DAO Watch. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
